// /src/components/Signin.jsx
import React, { useState, useContext } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import "./Signin.css";

function Signin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await login(username, password);
      navigate("/dashboard");
    } catch (error) {
      setError(error.message || "Error connecting to server. Please try again later.");
      console.error("Login error:", error);
    }
  };

  return (
    <div className="bg-light">
      <div className="container">
        <div className="login-card">
          <div className="login-header">
            <h2>Welcome Back!</h2>
            <p style={{ textAlign: "center" }}>Login to continue</p>
          </div>
          <img src="img/Webnet-Logo.png" alt="Logo" className="logo" />

          <div className="divider">
            <span>OR</span>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                placeholder="Enter your Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && <p className="error-message" style={{ color: "red", textAlign: "center" }}>{error}</p>}
            <button type="submit" className="btn submit-btn">Log In</button>
          </form>

          <div className="signup-text">
            <p>
              <NavLink to="/forgetpassword">Forgot Password?</NavLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signin;